module.exports = __webpack_public_path__ + "static/img/10.02823f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/10.png
// module id = MOBf
// module chunks = 37